export const columnTypes = {
  centerAligned: {
    cellStyle: { textAlign: 'center' },
    headerClass: ['text-center']
  },

  cellLeftAligned: {
    cellStyle: { textAlign: 'left' }
  },

  setFilterColumn: {
    filter: 'agSetColumnFilter',
    floatingFilterComponentFramework: 'SetFilter',
    filterParams: {
      suppressSelectAll: true
    }
  },

  textFilterColumn: {
    filter: 'agTextColumnFilter',
    floatingFilterComponentFramework: 'TextOrNumberFilter'
  },

  numberFilterColumn: {
    filter: 'CustomFilter',
    floatingFilterComponentFramework: 'TextOrNumberFilter'
  }
}
